import type { AxiosResponse } from 'axios'
import type { GraphQLCompanyResponse } from './types'

// TEMPORARY: opt-in until all endpoints are migrated
const INCLUDE_PATHS: RegExp[] = [
  /\/company\/graphql_dispatch\/worker_profile_a166b359/, // getWorkerProfile
  /\/company\/graphql_dispatch\/current_company_2cbd6697/, // getChargeAccounts
  /\/v1\/company\/[^/]+\/worker\/[^/]+\/shifts/, // getCompanyWorkerShifts
  /\/v1\/company\/[^/]+\/position\/templates/, // getPositionTemplates
  /\/company\/graphql_dispatch\/\d+\/company_worker_logs_7f70e3ee/, // getCompanyWorkerLogs
  /\/company\/graphql_dispatch\/\d+\/company_logs_f227532f/, // getCompanyLogs
  /\/company\/graphql_dispatch\/stripe_ach_url_c57e4c8f/, // getStripeACHUrl
  /\/company\/graphql_dispatch\/current_company_01b74516/, // getChargeLimits
  /\/company\/graphql_dispatch\/employer_guidance_029285ba/, // getEmployerGuidance
  /\/company\/graphql_dispatch\/company_insight_ef6beefc/, // getInsight
  /\/company\/graphql_dispatch\/current_company_e542fced/, // getCurrentCompanyInfo
  /\/company\/graphql_dispatch\/current_company_7a77e0eb/, // demo getCompanyInfo
]

function shouldParseResponse(response: AxiosResponse<unknown>): boolean {
  const path = response.config.url ?? ''

  return INCLUDE_PATHS.some((regex) => regex.test(path))
}

function isGraphQLCompanyResponse<T>(
  body: unknown
): body is GraphQLCompanyResponse<T> {
  if (typeof body !== 'object' || body === null) {
    return false
  }

  const { data } = body as GraphQLCompanyResponse<T>
  return typeof data === 'object' && data !== null && 'company' in data
}

export const parseResponseData = <T = unknown>(
  response: AxiosResponse<unknown>
) => {
  if (!shouldParseResponse(response)) {
    return response
  }

  if (isGraphQLCompanyResponse<T>(response.data)) {
    response.data = response.data.data.company
  }

  response.data = response.data as T

  return response
}
